// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var _obj;
export var cyan = (_obj = {}, _define_property(_obj, 50, '#ECFEFE'), _define_property(_obj, 100, '#DEFCFC'), _define_property(_obj, 200, '#BAF7F7'), _define_property(_obj, 300, '#91F3F3'), _define_property(_obj, 400, '#5EEDED'), _define_property(_obj, 500, '#23E7E7'), _define_property(_obj, 600, '#18DCDC'), _define_property(_obj, 700, '#14B8B8'), _define_property(_obj, 800, '#0F8A8A'), _define_property(_obj, 900, '#085E5E'), _define_property(_obj, 950, '#042F2F'), _obj);

//# sourceMappingURL=cyan.js.map